module.exports = __webpack_public_path__ + "static/media/fly0031.7d2cc5ad.webp";